import { cn } from 'v5/platform/dom/cn';

/** A thin progress bar laid over a thumbnail's bottom edge. */
export function UploadProgressBar({
  progress,
  className
}: {
  progress: number;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'h-1 overflow-hidden rounded-full bg-bg-default/80 shadow-sm',
        className
      )}
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full rounded-full bg-brand-500 transition-[width] duration-300"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
